//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../helpers/firebase_helper";
import axios from "axios";
import { postFakeLogin, postJwtLogin } from "../../helpers/fakebackend_helper";
import { jwtDecode } from "jwt-decode";
import { getAuthHeader } from '../../helpers/jwt-token-access/auth-token-header'
import {
  apiError,
  subcontractorSuccess,
  singleSubcontractorSuccess
} from "./reducer";

import apiUrl, { localPath } from "slices/apiEndpoint";
import api from "Common/api";

//create property owners


export const createContSubcontractors = (sub: any) => async (dispatch: any) => {
    const headers = getAuthHeader();
  if (!headers) {
    return;
  }

  try {
    const subcontractorEndpoint = `/subcontractor/create-subcontractor`;

    // Ensure getDecodeId() returns a valid value
    const contractorId = getDecodeId();
    if (!contractorId) {
      console.error("Error: Contractor ID not found");
      return;
    }

    let data = {
      subContractorFirstname: sub.firstName,
      subContractorLastName: sub.lastName,
      subContractorEmail: sub.email,
      subContractorPhone: sub.contact,
      subContractorStatus: sub.status,
      contractorId: contractorId
    };

    const resp = await api.post(subcontractorEndpoint, data, {
     headers
    });

     if (resp && resp.data && resp.data.message) {
      // Return success response
      return { data: resp.data.message };
    } else {
      // Return error response
      return { error: "Invalid response format from server" };
    }
  } catch (error: any) {
    // Handle and return error
    const errorMessage =
      error.response?.data?.message || "User Email Already Exist";
    return { error: errorMessage };
  }
};
export const getSubcontractors = () => async (dispatch: any) => {
     const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const subcontractorEndPoint = `/subcontractor/get-subcontractores/${getDecodeId()}`;

    const resp = await api.get(subcontractorEndPoint, {headers});
    if (resp) {
      dispatch(subcontractorSuccess(resp))
      return resp
    } else {
      dispatch(apiError("Error fetching contractors: Invalid response format"));
    }
  } catch (error) {
    dispatch(apiError(error));
    // Handle the error, e.g., set an error state
  }
};

export const getSingleSubcontractor = (subId: any) => async (dispatch: any) => {
  const headers = getAuthHeader();
  if (!headers) {
    return;
  }
  try {
    const singleSubcontractorEndPoint = `/subcontractor/get-single-subcontractor/${getDecodeId()}/${subId}`;

    const resp = await api.get(singleSubcontractorEndPoint, {headers});
    if (resp) {
      dispatch(singleSubcontractorSuccess(resp))
      return resp
    } else {
      dispatch(apiError("Error fetching contractors: Invalid response format"));
    }
  } catch (error) {
    dispatch(apiError(error));
    // Handle the error, e.g., set an error state
  }
};


function getDecodeId() {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode(token);
  } else {
    console.error("Token is null");
  }
  return decoded.userId;
}

 export function getDecodedUserName() {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode(token);
  } else {
    console.error("Token is null");
  }
  return decoded.firstName;
}
